import { __awaiter } from "tslib";
import { createSlice } from '../context';
import { marksCtx, nodesCtx, schemaCtx, SchemaReady } from '../internal-plugin';
import { createTimer } from '../timing';
import { getAtom } from '../utility';
export const inputRulesCtx = createSlice([], 'inputRules');
export const inputRulesTimerCtx = createSlice([], 'inputRulesTimer');
export const InputRulesReady = createTimer('InputRulesReady');
export const inputRules = (pre) => {
    pre.inject(inputRulesCtx).inject(inputRulesTimerCtx, [SchemaReady]).record(InputRulesReady);
    return (ctx) => __awaiter(void 0, void 0, void 0, function* () {
        yield ctx.waitTimers(inputRulesTimerCtx);
        const nodes = ctx.get(nodesCtx);
        const marks = ctx.get(marksCtx);
        const schema = ctx.get(schemaCtx);
        const getInputRules = (atoms, isNode) => atoms
            .map((x) => [getAtom(x.id, schema, isNode), x.inputRules])
            .flatMap(([atom, inputRules]) => atom && (inputRules === null || inputRules === void 0 ? void 0 : inputRules(atom, schema)))
            .filter((x) => !!x);
        const inputRules = [...getInputRules(nodes, true), ...getInputRules(marks, false)];
        ctx.set(inputRulesCtx, inputRules);
        ctx.done(InputRulesReady);
    });
};
//# sourceMappingURL=input-rules.js.map